import React from 'react';
import { useSelector } from 'react-redux';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { USER_LOGIN_ROUTE } from '~/src/constants/routes';
import Layout from '~/src/features/_layout';
import { isSso } from '~/src/features/user/helpers';
import { initialProps } from '~/src/helpers/basePageFunc';
import { nonPermanentRedirect } from '~/src/helpers/url';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const Login = dynamic(() => import('~/src/features/user/Login'));

/**
 * todo временное решение по WEB-43859, пока нет возможности определить кобренд и получить конкретный документ
 */
const COBRAND_DATA: Record<number, string> = {
    41: 'https://cdn-b2c.dom.ru/content/static/files/document/4e775a351712d527541bcaeeb6da13a2.pdf',
};

interface IProps {
    policyLink?: string,
}

const LoginPage: NextPage<IProps> = ({ policyLink }) => {
    const city = useSelector(getCurrentCity);
    const companyName = useSelector(selectCompanyName);

    return (<Layout
            title={'Авторизация в личном кабинете ' + companyName}
            description={'Авторизация в личном кабинете ' + companyName + '. Оплачивайте услуги без комиссии, ' +
                'подключайте новые тарифные планы, воспользуйтесь скидками и подарками для клиентов ' + companyName}
            withMenu={true}
            withChat={true}
            bgColor={COLORS.BgMain}
        >
            <Login plAvailable={!!city.plAvailable} policyLink={policyLink}/>
        </Layout>
    );
};

LoginPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });

    const state = options.store.getState();
    const providerId = selectProviderId(state);

    if (isSso()) {
        const { res } = options;
        nonPermanentRedirect({
            res,
            location: USER_LOGIN_ROUTE,
        });
    }

    if (providerId in COBRAND_DATA) {
        return { policyLink: COBRAND_DATA[providerId] };
    }

    return {};
};

export default LoginPage;
